import { render, staticRenderFns } from "./Photographies.vue?vue&type=template&id=0bbbbce7&scoped=true&"
import script from "./Photographies.vue?vue&type=script&lang=js&"
export * from "./Photographies.vue?vue&type=script&lang=js&"
import style0 from "./Photographies.vue?vue&type=style&index=0&id=0bbbbce7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbbbce7",
  null
  
)

export default component.exports